module.exports = __webpack_public_path__ + "img/dash-card-leads.db33501f.svg";